import React from "react";

import "../../Common.scss";
import "./MenuSidebar.scss";

function MenuSidebar(props) {
  return (
    <div className="sidebar-menu">
      <div className="sidebar-overlay"></div>
      <div className="menu-sidebar">
        <ul className="menu-list">
          <li key="0">
            <a href="/" className="active">
              Marketplace
            </a>
          </li>
          <li key="1">
            <a href="/">Resource</a>
          </li>
          <li key="2">
            <a href="/">About</a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default MenuSidebar;
